import { createFileRoute, useParams } from '@tanstack/react-router'

import { PlatformNewInvoicePageV2 } from '../../../../../../components/pages/backoffice/platform/platform-new-invoice-page-v2.tsx'
import { InviteToLoginPage } from '../../../../../../components/templates/invite-to-login/invite-to-login-page.tsx'
import { useManagedByOrusOnlyPermissions } from '../../../../../../lib/use-managed-by-orus-only-permissions.ts'
import { usePermissions } from '../../../../../../lib/use-permissions.ts'

function RouteComponent() {
  const { subscriptionId } = useParams({ from: '/bo/contracts/$subscriptionId/invoices/new' })
  const { hasPermission } = usePermissions()
  const { hasManagedByOrusScopedPermission } = useManagedByOrusOnlyPermissions({
    subscriptionId,
    managedByOrusOnlyPermission: 'invoice.create.managedByOrusOnly',
  })
  if (!hasPermission('invoice.create') && !hasManagedByOrusScopedPermission) return <InviteToLoginPage />
  return <PlatformNewInvoicePageV2 />
}

export const Route = createFileRoute('/bo/contracts/$subscriptionId/invoices/new')({
  component: RouteComponent,
})
